<script>
export default {
  name: "PaginatedList",
  props: {
    items: {
      type: Array,
      required: true
    },
    pageSize: {
      type: Number,
      default: 5
    },
    filterKey:{
      type: String,
      default: "productType"
    }
  },
  data(){
    return{
      currentPage: 1,
      selectedCategory: 'All',
      menuVisible: false
    }
  },
  computed:{
    uniqueCategories(){
      const categories = this.items.map(item => item[this.filterKey]).filter(Boolean)
      return ['All',...new Set(categories)];
    },
    filteredItem(){
      if(this.selectedCategory === 'All'){
        return this.items
      }
      return this.items.filter(item => item[this.filterKey] === this.selectedCategory)
    },
    paginatedItems(){
      const start = (this.currentPage - 1) * this.pageSize
      return this.filteredItem.slice(start, start + this.pageSize)
    }
  },
  watch:{
    selectedCategory(){
      this.currentPage = 1
    }
  },
  methods:{
    handlePageChange(page){
      this.currentPage = page
      this.$nextTick(() => {
        this.$refs.paginatedListContainer?.scrollIntoView({
          behavior: 'smooth', // 平滑滚动
          block: 'start'      // 对齐到视口顶部
        })
      })
    },
    openMenu(){
      this.menuVisible = !this.menuVisible
    },
    handleSelected(menu){
      this.selectedCategory = menu
      this.menuVisible = false
    }
  }
}
</script>

<template>
<div class="paginated-list" ref="paginatedListContainer">
  <div class="select-categories" v-if="uniqueCategories.length > 1">
    <div class="select-content" @click="openMenu">
      <div class="categorize-select-text">{{selectedCategory}}</div>
      <div class="drop_down-icon">
        <i :class="menuVisible ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
      </div>
    </div>
    <div class="categorize-drop-menu" :class="{active: menuVisible}">
      <ul>
        <li v-for="(menu,index) in uniqueCategories" :key="`categorize-${index}`" @click="handleSelected(menu)">{{menu}}</li>
      </ul>
    </div>
  </div>
  <slot :paginatedItems="paginatedItems"></slot>
  <el-pagination
      class="pagination"
      layout="prev, pager, next"
      :total="filteredItem.length"
      :page-size="pageSize"
      :current-page.sync="currentPage"
      @current-change="handlePageChange"
  />
</div>
</template>

<style scoped lang="scss">
@use '@/styles/responsive.scss' as *;
.paginated-list{
  scroll-margin-top: 200px;
  .select-categories{
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .select-content{
      background: #FFFFFF;
      width: 42%;
      display: flex;
      align-items: center;
      border-radius: 40px;
      padding: 2.2% 3.3%;
      cursor: pointer;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
      .categorize-select-text{
        font-size: 27px;
        line-height: 25px;
        flex-grow: 1;
        text-align: center;
        font-weight: bold;
      }
      .drop_down-icon{
        i{
          font-size: 20px;
        }
      }
    }
    .categorize-drop-menu{
      position: absolute;
      top: 110%;
      left: 50%;
      transform: translateX(-50%);
      width: 42%;
      background: #FFFFFF;
      font-size: 27px;
      line-height: 60px;
      color: #5B2F18;
      border-radius: 35px;
      font-weight: bold;
      z-index: 1;
      max-height: 0;
      overflow: hidden;
      opacity: 0;
      pointer-events: none;
      transition: max-height .3s ease-in-out, opacity .2s ease-in;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
      ul{
        padding: 1.6rem 0;
        text-align: left;
        li{
          cursor: pointer;
          padding: 0 1rem;
          &:hover{
            background: #efeeed;
          }
        }
      }
    }
    .active{
      max-height: 500px;
      opacity: 1;
      pointer-events: auto; /* 显示时恢复点击 */
    }
  }
}
::v-deep(.pagination){
  text-align: center;
  margin-top: 20%;
  button{
    background: transparent;
    color: #5A2A00;
    vertical-align: middle;
    &:hover{
      color: #FFFFFF;
    }
    &:disabled{
      color: #5A2A00 !important;
      background: transparent;
    }
    i{
      font-size: 35px !important;
    }
  }
  .el-pager{
    li{
      font-size: 35px;
      line-height: 25px;
      background: transparent;
      padding: 8px 0;
      height: auto;
      margin: 0 3px;
      &:hover{
        color: #FFFFFF;
      }

    }
    .active{
      color: #FFFFFF;
      background: #ce2c2c;
    }
  }
}
@include media-max(lg){
  .paginated-list{

    .select-categories{
      margin-top: 0;
      margin-bottom: 27px;
      .select-content{
        width: 60%;
      }
      .categorize-drop-menu{
        width: 60%;
      }
    }
  }
}
@include media-max(md){
  .paginated-list{
    .select-categories{
      margin-top: 0;
      margin-bottom: 27px;
      .select-content{
        padding: 1.2% 2%;
        .categorize-select-text{
          font-size: 15px;

        }
      }
      .categorize-drop-menu{
        font-size: 15px;
        line-height: 30px;
        border-radius: 25px;
        ul{
          padding: 1rem 0;
          li{
            padding: 0 1rem;
          }
        }
      }
    }
  }
  ::v-deep(.pagination){
    button{
      i{
        font-size: 16px !important;
      }
    }
    .el-pager{
      li{
        font-size: 16px;
        line-height: 11px;
        min-width: 20px;
        &:hover{
          color: #FFFFFF;
        }
      }
    }
  }
}
</style>